module.exports = "https://r.zoocdn.com/_next/static/other/browserconfig-64b2dc51e0bdc362c9f80fa326ea608b.xml";